import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	customerWelcomeBannerSubtitle: {
		id: 'fastshift.dashboard.customer-welcome-banner.subtitle',
		defaultMessage: 'Welcome to the FastShift Portal.',
		description: 'Subtitle for the customer welcome banner',
	},
});
